import {Configuration, RfpAutomationApi, RfpBidRequest} from '@shipwell/backend-core-sdk';
import {basePath} from 'App/api/config';
import {getAccessToken} from 'App/api/utils';

function createRfpApi() {
  return new RfpAutomationApi(
    new Configuration({
      basePath,
      apiKey: getAccessToken
    })
  );
}

interface RfpBidOptions {
  pageSize: number;
  page: number;
}

export function createRfpBid(rfpBidRequest: RfpBidRequest) {
  return createRfpApi().rfpAutomationRfpBidsPost(rfpBidRequest);
}

export function getRfpImportResults(rfpBidId: string) {
  return createRfpApi().rfpAutomationRfpBidsRfpBidIdPostImportResultsGet(rfpBidId);
}

export const getRfpDetails = (rfpBidId: string) => {
  return createRfpApi().rfpAutomationRfpBidsRfpBidIdGet(rfpBidId);
};

type RfpRowParameters = Parameters<typeof RfpAutomationApi.prototype.rfpAutomationRfpBidsRfpBidIdRfpRowsGet>;
export type RfpRowNamedParameters = {
  page?: RfpRowParameters[1];
  pageSize?: RfpRowParameters[2];
  ordering?: RfpRowParameters[3];
  originCity?: RfpRowParameters[4];
  originCityContains?: RfpRowParameters[5];
  originState?: RfpRowParameters[6];
  originStateContains?: RfpRowParameters[7];
  originPostalCode?: RfpRowParameters[8];
  originPostalCodeContains?: RfpRowParameters[9];
  destinationCity?: RfpRowParameters[10];
  destinationCityContains?: RfpRowParameters[11];
  destinationState?: RfpRowParameters[12];
  destinationStateContains?: RfpRowParameters[13];
  destinationPostalCode?: RfpRowParameters[14];
  destinationPostalCodeContains?: RfpRowParameters[15];
  carrierReference?: RfpRowParameters[16];
  carrierReferenceContains?: RfpRowParameters[17];
  carrierName?: RfpRowParameters[18];
  carrierNameContains?: RfpRowParameters[19];
  rowIdentifier?: RfpRowParameters[20];
  rowIdentifierContains?: RfpRowParameters[21];
  mode?: RfpRowParameters[22];
  equipment?: RfpRowParameters[23];
  q?: RfpRowParameters[24];
};

export const getRfpRows = (rfpBidId: string, queryParams: RfpRowNamedParameters) => {
  return createRfpApi().rfpAutomationRfpBidsRfpBidIdRfpRowsGet(
    rfpBidId,
    queryParams.page,
    queryParams.pageSize,
    queryParams.ordering,
    queryParams.originCity,
    queryParams.originCityContains,
    queryParams.originState,
    queryParams.originStateContains,
    queryParams.originPostalCode,
    queryParams.originPostalCodeContains,
    queryParams.destinationCity,
    queryParams.destinationCityContains,
    queryParams.destinationState,
    queryParams.destinationStateContains,
    queryParams.destinationPostalCode,
    queryParams.destinationPostalCodeContains,
    queryParams.carrierReference,
    queryParams.carrierReferenceContains,
    queryParams.carrierName,
    queryParams.carrierNameContains,
    queryParams.rowIdentifier,
    queryParams.rowIdentifierContains,
    queryParams.mode,
    queryParams.equipment,
    queryParams.q
  );
};

export const getRfpBids = async (opts: RfpBidOptions = {page: 1, pageSize: 1000}) => {
  const axiosResponse = await createRfpApi().rfpAutomationRfpBidsGet(opts.page, opts.pageSize);
  return axiosResponse.data;
};

export const updateRfpBid = (rfpBidId: string, body: RfpBidRequest) => {
  return createRfpApi().rfpAutomationRfpBidsRfpBidIdPut(rfpBidId, body);
};

export const getRfpCsv = (rfpBidId: string) => {
  return createRfpApi().rfpAutomationRfpBidsRfpBidIdExportCsvGet(rfpBidId);
};

export const deleteRfpBid = (rfpBidId: string) => {
  return createRfpApi().rfpAutomationRfpBidsRfpBidIdDelete(rfpBidId);
};
